import {gql} from '@apollo/client';

import {Image} from 'web-app/api/shared-fragments';

export const NoteAcknowledgement = gql`
    fragment NoteAcknowledgement on ChildNoteSignature {
        id
        targetId
        acknowledgedAt
        acknowledgedBy {
            name {
                fullName
            }
        }
    }
`;

export const Note = gql`
    fragment Note on ChildNote {
        __typename
        noteType
        child {
            id
            institutionId
        }
        modifiedAt
        modifiedBy {
            ...Author
        }
        createdBy {
            ...Author
        }
        id: noteId
        parentVisible
        sensitive
        text
        safeguardingConcern
        createdAt
        publishedAt
        files {
            id
            name
            url
        }
        images {
            ...Image
        }
        behaviors {
            id: behaviorId
        }
        parentAcknowledgements {
            ...NoteAcknowledgement
        }
    }
    fragment Author on Person {
        name {
            fullName
        }
        profileImage {
            url
        }
    }
    ${NoteAcknowledgement}
    ${Image}
`;

export const GetChildNotes = gql`
    query GetChildNotes(
        $childId: ChildId!
        $cursor: ChildNoteCursor
        $limit: Int!
        $parentVisible: Boolean
        $safeguardingConcern: Boolean
        $sensitive: Boolean
        $noteIds: [ChildNoteId!]
        $noteTypes: [ChildNoteType!]
        $showDrafts: Boolean
        $isAcknowledgedByParent: Boolean
    ) {
        childNotes(
            childIds: [$childId]
            cursor: $cursor
            limit: $limit
            parentVisible: $parentVisible
            safeguardingConcern: $safeguardingConcern
            sensitive: $sensitive
            noteIds: $noteIds
            noteTypes: $noteTypes
            drafts: $showDrafts
            isAcknowledgedByParent: $isAcknowledgedByParent
        ) {
            __typename
            next
            result {
                ...Note
            }
        }
    }
    ${Note}
`;

const BehaviorShowChildNotes = gql`
    fragment BehaviorShowChildNotes on BehaviorShowChildNotes {
        __typename
        behaviorId
        acknowledge
        safeguarding
        sensitive
        view
        regular
    }
`;
const BehaviorCanCreateChildNote = gql`
    fragment BehaviorCanCreateChildNote on BehaviorCanCreateChildNote {
        __typename
        behaviorId
        draft
        publish
        safeguarding
        sensitive
        regular
    }
`;

export const GetChildNoteBehaviors = gql`
    query GetChildNoteBehaviors($childId: ChildId!) {
        childNotes(childIds: [$childId], limit: 0) {
            behaviors {
                behaviorId
                __typename
                ... on BehaviorShowChildNotes {
                    ...BehaviorShowChildNotes
                }
                ... on BehaviorCanCreateChildNote {
                    ...BehaviorCanCreateChildNote
                }
            }
        }
    }
    ${BehaviorShowChildNotes}
    ${BehaviorCanCreateChildNote}
`;
